module.exports = __webpack_public_path__ + "static/media/category10.ec675617.jpg";